import { APIClient } from "./api_helper";
import * as url from "./url_helper"
import {GET_ATTRIBUTE_SEARCH} from "./url_helper";
const api = new APIClient();

// Login Method
export const login = (data: any) => api.adminLogin(url.LOGIN, data);

// Product
export const getProducts = (data: any, pagination: any) => api.getProduct(url.GET_PRODUCT, pagination, data);
export const getProductById = (id: any) => api.getProductById(url.GET_PRODUCT_BY_ID, id);
export const createProduct = (data: any) => api.createProduct(url.ADD_NEW_PRODUCT, data);
export const deleteProducts = (id: any) => api.deleteById(url.DELETE_PRODUCT, id);
export const updateProduct = (data: any, id: any) => api.updateByID(url.UPDATE_PRODUCT + "/" + id, data);

//Category
export const getCategoryList = () => api.getData(url.GET_CATEGORY_LIST, null);
export const searchCategoryList = (data: any, pagination: any) => api.getNews(url.SEARCH_CATEGORY_LIST, pagination, data);
export const addCategoryList = (data: any) => api.createCategory(url.ADD_CATEGORY_LIST, data);
export const updateCategoryList = (data: any) => api.updateByID(url.UPDATE_CATEGORY_LIST + "/" + data.id, data.updateFormData);
export const deleteCategoryList = (id: any) => api.deleteById(url.DELETE_CATEGORY_LIST, id);

//Brand
export const getBrandList = () => api.getData(url.GET_BRAND_LIST, null);
export const searchBrandList = (data: any, pagination: any) => api.getNews(url.SEARCH_BRAND_LIST, pagination, data);
export const addBrandList = (data: any) => api.createCategory(url.ADD_BRAND_LIST, data);
export const updateBrandList = (data: any) => api.updateByID(url.UPDATE_BRAND_LIST + "/" + data.id, data.updateFormData);
export const deleteBrandList = (id: any) => api.deleteById(url.DELETE_BRAND_LIST, id);

//Attribute
export const getAttributeList = () => api.getData(url.GET_ATTRIBUTE_LIST, null);
export const getAttributeSearch = (searchData:any) => api.getDataSearch(url.GET_ATTRIBUTE_SEARCH, searchData);
export const addAttributeList = (data: any) => api.createCategory(url.ADD_ATTRIBUTE_LIST, data);
export const updateAttributeList = (data: any) => api.updateByID(url.UPDATE_ATTRIBUTE_LIST + "/" + data.id, data);
export const deleteAttributeList = (id: any) => api.deleteById(url.DELETE_ATTRIBUTE_LIST, id);

//Discount
export const getDiscountList = () => api.getData(url.GET_DISCOUNT_LIST, null);
export const searchDiscountList = (searchData: any) => api.getDataSearch(url.SEARCH_DISCOUNT_LIST, searchData);
export const addDiscountList = (data: any) => api.createCategory(url.ADD_DISCOUNT_LIST, data);
export const updateDiscountList = (data: any) => api.updateByID(url.UPDATE_DISCOUNT_LIST + "/" + data.id, data);
export const deleteDiscountList = (id: any) => api.deleteById(url.DELETE_DISCOUNT_LIST, id);

//Colors
export const getColorsList = () => api.getData(url.GET_COLORS_LIST, null);
export const searchColorsList = (data: any, pagination: any) => api.getNews(url.SEARCH_COLORS_LIST, pagination, data);
export const addColorsList = (data: any) => api.create(url.ADD_COLORS_LIST, data);
export const updateColorsList = (data: any) => api.updateColor(url.UPDATE_COLORS_LIST + "/" + data.id, data);
export const deleteColorsList = (id: any) => api.deleteById(url.DELETE_COLORS_LIST, id);

// model
export const getModelList = () => api.getData(url.GET_MODEL_LIST, null);
export const searchModelList = (data: any, pagination: any) => api.getNews(url.SEARCH_MODEL_LIST, pagination, data);
export const addModelList = (data: any) => api.createCategory(url.ADD_MODEL_LIST, data);
export const updateModelList = (data: any) => api.updateByID(url.UPDATE_MODEL_LIST + "/" + data.id, data);
export const deleteModelList = (id: any) => api.deleteById(url.DELETE_MODEL_LIST, id);

//News
export const getNewsList = (data: any, pagination: any) => api.getNews(url.GET_NEWS_LIST,  pagination, data);
export const addNewsList = (data: any) => api.createCategory(url.ADD_NEWS_LIST, data);
export const updateNewsList = (data: any, id: any) => api.updateByID(url.UPDATE_NEWS_LIST + "/" + id, data);
export const deleteNewsList = (id: any) => api.deleteById(url.DELETE_NEWS_LIST, id);
export const getNewsById = (id: any) => api.getNewsById(url.GET_NEWS_BY_ID, id);

// SubMenu
export const getSubMenu = () => api.getData(url.GET_SUB_MENU, null);
export const searchSubMenu = (data: any, pagination: any) => api.getNews(url.SEARCH_SUB_MENU, pagination, data);
export const createSubMenu = (data: any) => api.create(url.CREATE_SUB_MENU, data);
export const updateSubMenu = (data: any) => api.updateColor(url.UPDATE_SUB_MENU + "/" + data.id, data);
export const deleteSubMenu = (id: any) => api.deleteById(url.DELETE_SUB_MENU, id);

//Block
export const getBlockList = (data: any, pagination: any) => api.getNews(url.GET_BLOCK_LIST,  pagination, data);
export const addBlockList = (data: any) => api.create(url.ADD_BLOCK_LIST, data);
export const updateBlockList = (data: any, id: any) => api.updateByID(url.UPDATE_BLOCK_LIST + "/" + id, data);
export const deleteBlockList = (id: any) => api.deleteById(url.DELETE_BLOCK_LIST, id);
export const getBlockById = (id: any) => api.getNewsById(url.GET_BLOCK_BY_ID, id);

// HomeLayout
export const getHomeLayout = () => api.getData(url.GET_HOME_LAYOUT, null);
export const searchHomeLayout = (data: any, pagination: any) => api.getNews(url.SEARCH_HOME_LAYOUT, pagination, data);
export const createHomeLayout = (data: any) => api.create(url.CREATE_HOME_LAYOUT, data);
export const updateHomeLayout = (data: any) => api.updateColor(url.UPDATE_HOME_LAYOUT + "/" + data.id, data);
export const deleteHomeLayout = (id: any) => api.deleteById(url.DELETE_HOME_LAYOUT, id);

//Banner
export const getBannerList = (data: any, pagination: any) => api.getNews(url.GET_BANNER_LIST, pagination, data);
export const addBanner = (data: any) => api.createCategory(url.ADD_BANNER, data);
export const updateBanner = (data: any) => api.updateByID(url.UPDATE_BANNER + "/" + data.id, data.updateFormData);
export const deleteBanner = (id: any) => api.deleteById(url.DELETE_BANNER, id);

// Badge
export const getBadge = () => api.getData(url.GET_BADGE, null);
export const searchBadge = (data: any, pagination: any) => api.getNews(url.SEARCH_BADGE, pagination, data);
export const createBadge = (data: any) => api.create(url.CREATE_BADGE, data);
export const updateBadge = (data: any) => api.updateColor(url.UPDATE_BADGE + "/" + data.id, data);
export const deleteBadge = (id: any) => api.deleteById(url.DELETE_BADGE, id);

